"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
var swiper_1 = require("swiper");
require("@lottiefiles/lottie-player");
var modules_1 = require("swiper/modules");
require("swiper/swiper-bundle.css");
require("../scss/style.scss");
/* =================================================== */
// Smooth Scroll
/* =================================================== */
// スムーススクロール
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();
        var href = anchor.getAttribute("href");
        var target = document.getElementById(href.replace("#", ""));
        var targetPosition = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
    });
});
/* =================================================== */
// ヘッダーの背景変化
/* =================================================== */
//リクルートサイトトップ
var header = document.getElementById("js-headerInner");
if (header) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("js-kv").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            header.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            header.classList.remove("is-bgWhite");
        }
    });
}
//インタビューページ01
var headerInner01 = document.getElementById("js-header-inner01");
if (headerInner01) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("interview-kv01").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            headerInner01.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            headerInner01.classList.remove("is-bgWhite");
        }
    });
}
//インタビューページ02
var headerInner02 = document.getElementById("js-header-inner02");
if (headerInner02) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("interview-kv02").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            headerInner02.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            headerInner02.classList.remove("is-bgWhite");
        }
    });
}
//インタビューページ03
var headerInner03 = document.getElementById("js-header-inner03");
if (headerInner03) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("interview-kv03").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            headerInner03.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            headerInner03.classList.remove("is-bgWhite");
        }
    });
}
//インタビューページ04
var headerInner04 = document.getElementById("js-header-inner04");
if (headerInner04) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("interview-kv04").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            headerInner04.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            headerInner04.classList.remove("is-bgWhite");
        }
    });
}
//インタビューページ05
var headerInner05 = document.getElementById("js-header-inner05");
if (headerInner05) {
    window.addEventListener("scroll", function () {
        var scrollpoint = window.scrollY; //現在のスクロール位置を取得
        var kvHeight = document.getElementById("interview-kv05").offsetHeight; //メインビジュアル領域の高さを取得
        if (kvHeight < scrollpoint) {
            //ロゴをアクティブにするクラスを付与
            headerInner05.classList.add("is-bgWhite");
        }
        else {
            //ロゴをアクティブにするクラスを除去
            headerInner05.classList.remove("is-bgWhite");
        }
    });
}
/* =================================================== */
// 追従ボタン
/* =================================================== */
window.onload = function () {
    var followingBtn = document.getElementById("followingBtn");
    if (followingBtn) {
        var entryArea = document.getElementById("entry");
        var entryAreaRect = entryArea.getBoundingClientRect();
        var entryAreaY_1 = entryAreaRect.top + scrollY;
        console.log(entryAreaY_1);
        window.addEventListener("scroll", function () {
            var currentY = window.scrollY;
            if (currentY > entryAreaY_1) {
                followingBtn.classList.add("is-hidden");
            }
            else {
                followingBtn.classList.remove("is-hidden");
            }
        });
    }
};
/* =================================================== */
// drower menu
/* =================================================== */
var menuBtn = document.querySelector("#js-menu-btn");
var nav = document.querySelector("#js-nav");
menuBtn.addEventListener("click", function () {
    menuBtn.classList.toggle("is-active");
    nav.classList.toggle("is-active");
});
document.addEventListener("DOMContentLoaded", function () {
    function menuClick() {
        menuBtn.classList.remove("is-active");
        nav.classList.remove("is-active");
    }
    // 引数に指定したclassの値をもつ要素をすべて取得
    var navLink = document.querySelectorAll(".js-navLink");
    // 上記で取得したすべての要素に対してクリックイベントを適用
    for (var i = 0; i < navLink.length; i++) {
        navLink[i].addEventListener("click", menuClick, false);
    }
}, false);
window.addEventListener("DOMContentLoaded", function () {
    var loader = document.getElementById("loading");
    if (loader) {
        var removeActive = function () {
            loader.classList.remove("is-active");
        };
        setTimeout(removeActive, 1500);
    }
});
/* =================================================== */
// Swiper
/* =================================================== */
swiper_1.default.use([modules_1.Navigation, modules_1.Pagination, modules_1.Autoplay]);
var swiper = new swiper_1.default(".swiper-interview", {
    modules: [modules_1.Navigation, modules_1.Pagination],
    effect: "fade",
    fadeEffect: {
        crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    },
    slidesPerView: 1,
    spaceBetween: 25,
    centeredSlides: true,
    loop: true,
    speed: 300,
    autoplay: {
        // 自動再生させる
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    breakpoints: {
        744: {
            slidesPerView: 2,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
    },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
/* =================================================== */
// スクロールアニメーション スライドアップフェード
/* =================================================== */
var slideUpElement = document.querySelectorAll(".js-slideUp");
for (var i = 0; i < slideUpElement.length; i++) {
    gsap_1.gsap.set(slideUpElement[i], { opacity: 0, y: 50 }); //初期状態をセット
    gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
    ScrollTrigger_1.ScrollTrigger.batch(slideUpElement[i], {
        onEnter: function (batch) {
            return gsap_1.gsap.to(batch, {
                opacity: 1,
                y: 0,
            });
        },
        start: function () { return "top 90%"; },
        once: true,
        pin: false,
    });
}
/* =================================================== */
// スクロールアニメーション フェードイン
/* =================================================== */
var fadeInElement = document.querySelectorAll(".js-fadeIn");
for (var i = 0; i < fadeInElement.length; i++) {
    gsap_1.gsap.set(fadeInElement[i], { opacity: 0 }); //初期状態をセット
    gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
    ScrollTrigger_1.ScrollTrigger.batch(fadeInElement[i], {
        onEnter: function (batch) {
            return gsap_1.gsap.to(batch, {
                opacity: 1,
            });
        },
        start: function () { return "top 80%"; },
        once: true,
        pin: false,
    });
}
/* =================================================== */
// スクロールアニメーション 画像のブラー
/* =================================================== */
var blurOutElement = document.querySelectorAll(".js-blurOut");
for (var i = 0; i < blurOutElement.length; i++) {
    gsap_1.gsap.set(blurOutElement[i], {
        opacity: 0,
        filter: "blur(10px)",
    }); //初期状態をセット
    gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
    ScrollTrigger_1.ScrollTrigger.batch(blurOutElement[i], {
        onEnter: function (batch) {
            return gsap_1.gsap.to(batch, {
                opacity: 1,
                filter: "blur(0)",
            });
        },
        start: function () { return "top 90%"; },
        once: true,
        pin: false,
    });
}
